import React, { useMemo } from 'react';
import { _ } from '@splunk/ui-utils/i18n';
import BaseVisualization from '@splunk/dashboard-visualizations/common/BaseVisualization';
import { parse, dataContract } from '@splunk/visualization-encoding-parsers/MarkerGaugeParser';
import SuiGaugeMarkerIcon from '@splunk/react-icons/enterprise/GaugeMarker';
import ReactMarkerGauge from '@splunk/react-visualizations/MarkerGauge';
import { withVisualizationAndThemeHOCs } from '@splunk/dashboard-visualizations/utils/enhancer';
import IconPlaceholder from '@splunk/dashboard-visualizations/common/IconPlaceholder';
import Message from '@splunk/visualizations-shared/Message';
import optionsSchema from './optionsSchema';
import editor from './editorConfig';

export const MarkerGaugeComponent = ({ dataSources, options, encoding, width, height }) => {
    /**
     * Pre-calculate props based on encoding
     */
    const propsFromEncoding = useMemo(() => parse(dataSources, encoding), [dataSources, encoding]);

    const areInvalidPropsFromEncoding = propsFromEncoding.valueType !== dataContract.encoding.value.type;

    return areInvalidPropsFromEncoding ? (
        <Message
            data-test="message"
            width={width}
            height={height}
            message={_(
                `Data type for value encoding is incorrect. Expected: "number", Received: "${propsFromEncoding.valueType}"`
            )}
            level="info"
        />
    ) : (
        <ReactMarkerGauge width={width} height={height} {...propsFromEncoding} {...options} />
    );
};

MarkerGaugeComponent.propTypes = BaseVisualization.propTypes;
MarkerGaugeComponent.defaultProps = {
    ...BaseVisualization.defaultProps,
    height: 250,
};
MarkerGaugeComponent.dataContract = dataContract;
MarkerGaugeComponent.vizContract = {
    initialDimension: {
        width: 300,
        height: 150,
    },
};
MarkerGaugeComponent.initialRequestParams = { offset: 0, count: 10000 };
MarkerGaugeComponent.supportedDataSources = ['primary'];
MarkerGaugeComponent.schema = optionsSchema;
MarkerGaugeComponent.editor = editor;

export default withVisualizationAndThemeHOCs({
    placeholder: <IconPlaceholder icon={<SuiGaugeMarkerIcon />} />,
})(MarkerGaugeComponent);
